import EDIT_CUSTOMER_TAB from '../../models/editCustomerTab.js';
import ROLES from '../../models/roles';

class EditCustomersController {

  constructor(customerService, localStorageService) {
    this.ROWS_PER_PAGE = 200;
    this.offset = 0;
    this.previousData = {
      content: []
    };
    this.name = 'editCustomers';
    this.customerService = customerService;
    this.customers = [];
    this.impersonationError = false;
    this.exportError = false;
    this.options = EDIT_CUSTOMER_TAB.options;
    this.localStorageService = localStorageService;
    this.searchValue = '';
    this.getCustomers();
  }

  isSuperAdmin() {
    return parseInt(this.localStorageService.get('role')) === ROLES.SUPER_ADMIN;
  }

  getCustomers() {
    let offset = this.offset;
    let limit = this.ROWS_PER_PAGE;
    let searchValue = this.searchValue;

    this.customerService.getCustomers(offset, limit, searchValue, this.isSuperAdmin())
      .then(this.onGetCustomersSuccess.bind(this));
  }

  getNextSetOfRowsToFetch() {
    this.getCustomers();
  }

  onGetCustomersSuccess(results) {
    if (results.data.content) {
      this.setPaginationData(results.data.content);
    }
  }

  setPaginationData(content) {
    this.updatedContent = this.previousData.content.concat(content);
    let updatedData = {
      content: this.updatedContent
    };
    this.data = updatedData;
    this.customers = this.data.content;
    this.previousData = this.data;
    this.offset += this.ROWS_PER_PAGE;
    this.metaData.customers.search.errors.NO_SEARCH_RESULTS = this.data.content.length === 0 ? true : false;
  }

  search() {
    this.searchValue = this.metaData.customers.search.value;
    this.resetPaginationDefaults();
    this.getCustomers();
  }

  resetPaginationDefaults() {
    this.offset = 0;
    this.previousData = {
      content: []
    };
  }
}

EditCustomersController.$inject = ['customerService', 'localStorageService'];


export
default EditCustomersController;


// WEBPACK FOOTER //
// ./app/components/editCustomers/editCustomers.controller.js